<template>
  <div
    class="modal-card"
    style="width: auto"
  >
    <section class="modal-card-body events-modal">
      <div class="element-events">
        <div class="element-thumbnail">
          <figure v-if="$attrs.thumbnailImage.length">
            <img
              v-for="thumbnail in $attrs.thumbnailImage"
              :src="thumbnail.url"
              :alt="thumbnail.altText"
              v-bind:key="thumbnail.id"
            />
          </figure>
          <figure v-else>
            <img :src="placeholderImage" />
          </figure>
        </div>
        <!--.element-thumbnail-->
        <div class="element-content">
          <p
            class="heading-4 overline"
            v-if="calendarType($attrs)"
          >{{calendarType($attrs)}}</p>
          <h3 class="heading-3">{{$attrs.title}}</h3>
          <p class="event-date is-larger">
            <span>{{eventDates($attrs.startDate,$attrs.endDate)}}</span>
            <span class="lowercase">{{eventTimes($attrs.startDate,$attrs.endDate)}}</span>
          </p>
          <p
            class="short-description is-serif"
            v-html="formatDescription($attrs.shortDescription)"
          ></p>
          <p
            v-if="$attrs.eventAddress"
            class="event-address"
          >
            <a
              target="_blank"
              class="is-external"
              :href="'https://www.google.com/maps/?q=' + formatAddressUrl($attrs.eventAddress)"
              v-html="formatAddressText($attrs.eventAddress)"
            ></a>
          </p>
          <div class="is-serif event-functions">
            <calendar-links
              :title="$attrs.title"
              :start="$attrs.startDate"
              :end="$attrs.endDate"
              :description="$attrs.shortDescription"
              :address="$attrs.eventAddress"
              tz="America/Detroit"
            ></calendar-links>
            <p>
              <a
                class="basic"
                :href="$attrs.url"
              >Share Event</a>
            </p>
          </div>
        </div>
        <!--.element-content-->
      </div>
      <!--.columns-->
    </section>
  </div>
</template>

<script>
import { formatEventDates, formatEventTimes } from '../utils/calendars.js'
import { placeholderImage } from '../utils/assetUrl'
import CalendarLinks from '../components/calendarLinks.vue'
export default {
  components: {
    CalendarLinks
  },
  data () {
    return { placeholderImage }
  },
  methods: {
    calendarType (result) {
      if (
        typeof result.schoolCalendar !== 'undefined' &&
        result.schoolCalendar.length !== 0
      ) {
        return result.schoolCalendar[0].title
      }
      if (
        typeof result.athleticCalendar !== 'undefined' &&
        result.athleticCalendar.length === 3
      ) {
        return (
          result.athleticCalendar[1].title +
          ' - ' +
          result.athleticCalendar[2].title
        )
      }
    },
    eventDates (startDate, endDate) {
      return formatEventDates(startDate, endDate)
    },
    eventTimes (startDate, endDate) {
      return formatEventTimes(startDate, endDate)
    },
    formatAddressText (address) {
      if (typeof address !== 'undefined') {
        address = address.replace(/\\(.)/gm, '<br />')
      }
      return address
    },
    formatAddressUrl (address) {
      if (typeof address !== 'undefined') {
        address = encodeURI(address.replace(/\\(.)/gm, '+'))
      }
      return address
    },
    formatDescription (description) {
      const txt = document.createElement('textarea')
      txt.innerHTML = description
      return txt.value
    }
  }
}
</script>
